import { environment } from '../../../environments/environment'

// Absolute URL for a token from PdfgetfilesService.preparePdfToOpen. The file
// name is the last path segment so the PDF viewer's download uses it.
export function pdfOpenUrl(token: string, fileName: string): string {
  const base = environment.apiUrl || window.location.origin
  return `${base}/api/FileManagerCredentials/OpenPdf/${token}/${encodeURIComponent(fileName)}`
}

// Renders a PDF URL inside a small wrapper page so the browser tab
// shows the real file name instead of the blob GUID / embedded PDF title.
// `win` must be a same-origin window (e.g. from window.open('', '_blank')).
export function showPdfInWindow(win: Window, pdfUrl: string, fileName: string): void {
  const escape = (value: string) =>
    value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')

  win.document.open()
  win.document.write(
    '<!doctype html><html><head><meta charset="utf-8">' +
      `<title>${escape(fileName)}</title>` +
      '<style>html,body{margin:0;height:100%;overflow:hidden}iframe{border:0;width:100%;height:100%}</style>' +
      `</head><body><iframe src="${escape(pdfUrl)}"></iframe></body></html>`,
  )
  win.document.close()
}
